import { Select } from "@mantine/core";

export const BaseSelect = Select;
